import loadable from '@loadable/component'
// import activity20221111 from './20221111'
// import activity20221212 from './20221212'
import NewUser2024 from './2024NewUser'

export default Object.assign(
    {
        // '/activity/fakao': loadable(() => import('./FakaoActivity')),
        // '/activity/fashuo': loadable(() => import('./FashuoActivity')),
        // '/activity/exam-signup': loadable(() => import('./examSignUp')),
        // '/activity/prepare2023': loadable(() => import('./prepare2023')),
            '/:type/activity/code/:id': loadable(() => import('./activity')),
        '/activity/new-year-goods': loadable(() => import('./2022NewYearGoods')),
        '/:type/activity/new-year-goods': loadable(() => import('./2022NewYearGoods')), // 活动需要保留法考、法硕业务类型 zhumavip.com/fakao|fashuo
        '/:type/activity/school-open': loadable(() => import('./2023SchoolOpen/Home')),
        '/:type/activity/no-closing': loadable(() => import('./NoClosing2022')),
        '/:type/activity/mockexam/:id': loadable(() => import('./MockExam')),
        '/:type/activity/2023-new-user': loadable(() => import('./2023NewUser')),
        '/fashuo/activity/2023promotion': loadable(() => import('./2023Promotion')),
        '/:type/activity/510plan': loadable(() => import('./2023510Plan')),
        '/:type/activity/618promotion': loadable(() => import('./2023618Activity')),
        '/:type/activity/noClosing2024': loadable(() => import('./NoClosing2024')),
    },
    NewUser2024
    // activity20221111, 双十一活动结束 移除路由
    // activity20221212, 双十二活动结束 移除路由
)
